<template>
    <div>
        <div style="margin:5px;font-weight:bold;">
            <font color="red">修改评标办法永远以第一版招标文件为模版进行修改，如想查看评标办法是否修改成功， 请点击 “查看评标办法”进行查看</font>
        </div>
        <my-table :data="tableData" :height="tableHeight" ref="table">
            <!-- <el-table-column label="编号" prop="guidcode" min-width="220" fixed></el-table-column> -->
            <el-table-column label="文件名称" prop="zbfilename">
                <template slot-scope="scope">
                    <span style="cursor:pointer;color:#409EFF;" @click="detail(scope.row)">{{scope.row.zbfilename}}</span>
                </template>
            </el-table-column>
            <el-table-column label="文件编码" prop="zbfilecode"></el-table-column>
            <el-table-column label="文件类型" prop="wjlx">
                <template slot-scope="scope">
                    <p v-if="scope.row.wjlx == 'wj'">
                        招标文件
                    </p>
                    <p v-if="scope.row.wjlx == 'cq'">
                        <span style="color:red;">澄清文件</span> 
                    </p>
                </template>
            </el-table-column>
            <el-table-column label="投标有效期(天)" prop="tbyxq"></el-table-column>
            <el-table-column label="投标文件递交截止时间(开标时间)" prop="tbwjdjjztime"></el-table-column>
            <el-table-column label="投标文件解密截止时间" prop="tbwjjmjzsj"></el-table-column>
            <el-table-column label="评标办法" prop="zbfilecode"> 
                <template slot-scope="scope">
                    <div v-if="scope.row.by4 == '1'">
                        <div v-if='"1" == dlxgpbbf'>
                            <el-button size="mini" icon="el-icon-edit" type="text" @click="editpbbfafterpwh(scope.row.bdcode)">修改评标办法(已组建评委会)</el-button>
                        </div>
                        <div v-else>
                            <el-tag size="mini">已经组建评标委员会，请申请修改</el-tag>
                        </div>
                    </div>
                    <div v-else-if="scope.row.by5 == '1' && scope.row.zbfilecode != scope.row.by1">
                        <el-tag size="mini">请在最新的澄清文件处，修改评标办法</el-tag>
                    </div>
                    <div v-else>
                        <my-btn type="edit" size="mini" @click="editPbbf(scope.row.by3,scope.row.by2)">修改评标办法</my-btn>
                    </div>
                    <my-btn type="detail" @click="showPbbf(scope.row.zbprocode)">查看评标办法</my-btn>
                </template>
            </el-table-column>
            
        </my-table>
        <my-pagination :do-layout="true" ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/FaBiao/ZbFile/Pbbf/list.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page';
import '@/js/ca/hebei/hebcaP11Object2.js'
import '@/js/ca/CAbase.js'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                procode:this.getQuery('procode'),
                sortname:'zbfilecode',
                recordpos: 'left',
                sortorder: "desc",
                viewrecords: true,
                rownumbers: true,
                editurl: 'del',
            },
            logindwname:"",
            dlxgpbbf:"",
        }
    },
    methods:{
        detail(row){
            var that = this;
            this.goto({
                path: '/bidding/projectflow/toubiao/bid-method-validate/detail',
                query: {
                    procode: that.getQuery('procode'),
                    zbfilecode: row.zbfilecode,
                }
            });
        },
        editPbbf:function(rowguid,loginname){
            var exepath = "";
            try{
				var shell = new ActiveXObject("wscript.shell");
			}catch(e){
				alert("启动工具失败,请检查1.是否已关闭保护模式 2.是否已设置“受信任站点” 3.是否已启用ActiveX控件。");
				return false;
			}
			try{
				var path = shell.RegRead("HKEY_CURRENT_USER\\Software\\RuihepmZB\\path");
				}catch(e){
				alert("启动工具失败,请确认是否已安装招标文件制作工具");
				return false;
			}
			try{
				if(path!=null && path!=undefined && path!=""){
					exepath = 'file://'+path+'ZHAOBIAO.exe'+"\""+' '+rowguid+' '+loginname;
					shell.run("\""+exepath);
				}else{
				    alert("启动工具失败,未查询到招标文件制作工具安装路径");
				}
			}catch(e){
                exepath = 'file://'+path+'ZHAOBIAO.exe'+"\""+' '+rowguid+' '+loginname;
                console.log(exepath)
				alert("启动工具失败");
			}
        },
        editpbbfafterpwh:function(bdcode){
            var that = this;
            useCA('hebeica', 'getcadwname', {}, function (res) {
                if (res.cadwname == that.logindwname) {
                    $.get(`${that.getGetters('bidUrl')}/FaBiao/ZbFile/Pbbf/gotoeditpbbfurl?r=`+Math.random()+"&bdcode="+bdcode,function(data){
                        if(data.result)
                        {
                            var url = data.tdata;
                            window.open(url);
                        }else{
                            ShowMsg(data.msg);
                        }
                    })
                } else {
                    ShowMsg("CA单位名称与当前登录单位名称不一致！");
                    return;
                }
            })
        },
        showPbbf:function(zbprocode){
            window.open("/mkzbfile/index.html#/pc/zbfile/tool/detail?bdcode="+zbprocode)
        },
        getJspData:function(){
            var that = this;
            $.get(`${that.getGetters('bidUrl')}/FaBiao/ZbFile/Pbbf/initlist.json?procode=${that.getQuery('procode')}`,function(data){
                that.dlxgpbbf = data.tdata.dlxgpbbf;
                that.logindwname = data.tdata.logindwname;
            })
        }
    },
    created(){
       useCA('hebeica', 'initialization', {}, function (res) {
            
        })
    },
    mounted(){
        this.getJspData();
    }
}
</script>

<style>

</style>